import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Modal, Button, Card, Input, Form, Select, RadioLabel, CurrencyInput } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import i18n from 'i18next';

export default function AddTaxesModal({ openModal, eventId, onClose, taxTree, taxEdit, saveEditTaxe, saveTaxeInTree, currancy, onEditTax }) {
    const { t } = useTranslation();
    const locale = i18n.language;

    const [value, setValue] = React.useState(taxEdit?.label || '');
    const [taxeGroupe, setTaxeGroupe] = React.useState(taxEdit?.id_category || undefined);
    const [plate, setPlate] = React.useState(taxEdit ? taxEdit.type === '0' : true);
    const [typeValue, setTypeValue] = React.useState(taxEdit ? taxEdit?.type_value === '0' : true);
    const [currancyValue, setCurrancyValue] = React.useState(taxEdit?.value || 0);
    const [loader, setLoader] = React.useState(false);

    return (
        <Modal
            open={Boolean(openModal)}
            onClose={onClose}
            onHide={onClose}
            size={'large'}
            title={t('ticket.tax.addTaxeModale.title')}
            submitButton={
                <Button
                    disabled={value.length === 0 || !taxeGroupe}
                    primary
                    onClick={() => {
                        setLoader(true);
                        if (taxEdit) {
                            onEditTax({
                                id_category: taxeGroupe,
                                label: value,
                                value: currancyValue,
                                type: plate ? '0' : '1',
                                type_value: typeValue ? '0' : '1',
                                base: plate ? '1' : '2',
                                id_evenement: eventId,
                                id_tax: taxEdit.id_tax
                            }).then(f => {
                                setLoader(false);
                                saveEditTaxe(f, taxeGroupe, taxEdit.id_tax);
                                onClose();
                            });
                        } else {
                            onEditTax({
                                id_evenement: eventId,
                                id_category: taxeGroupe,
                                base: plate ? '1' : '2',
                                label: value,
                                value: currancyValue,
                                type: plate ? '0' : '1',
                                type_value: typeValue ? '0' : '1'
                            }).then(f => {
                                setLoader(false);
                                saveTaxeInTree(f.response);
                                onClose();
                            });
                        }
                    }}
                    label={t('ticket.common.action.save')}
                />
            }
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} />}
        >
            {loader ? (
                <Loader active inline="centered" />
            ) : (
                <Card.Content className="contentCard">
                    <Form>
                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeModale.titleInputName')} />
                        <Form.Sublabel label={t('ticket.tax.addTaxeModale.subInputName')}></Form.Sublabel>
                        <Input value={value} onChange={event => setValue(event.target.value)} />

                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeModale.titleTaxeGroupe')} />
                        <Select
                            useNew
                            onChange={setTaxeGroupe}
                            value={taxeGroupe}
                            options={taxTree.map(obj => {
                                return { text: obj.name, value: obj.id_category };
                            })}
                            placeholder={t('ticket.tax.addTaxeModale.placeholderTaxeGroupe')}
                        />

                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeModale.plate')} />
                        <Card.Content>
                            <RadioLabel defaultChecked={plate} name="gender3" value={t('ticket.tax.revenueExcludingVAT')} inline bordered onClick={() => setPlate(true)}>
                                {t('ticket.tax.revenueExcludingVAT')}
                            </RadioLabel>
                            <RadioLabel defaultChecked={!plate} name="gender3" value={t('ticket.tax.payingAttendees')} inline bordered onClick={() => setPlate(false)}>
                                {t('ticket.tax.payingAttendees')}
                            </RadioLabel>
                        </Card.Content>

                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeModale.typeValue')} />
                        <Card.Content>
                            <RadioLabel
                                defaultChecked={typeValue}
                                name="gender1"
                                value={t('ticket.tax.addTaxeModale.percentage')}
                                inline
                                bordered
                                onClick={() => setTypeValue(true)}
                            >
                                {t('ticket.tax.addTaxeModale.percentage')}
                            </RadioLabel>
                            <RadioLabel
                                defaultChecked={!typeValue}
                                name="gender1"
                                value={t('ticket.tax.addTaxeModale.fixedAmount')}
                                inline
                                bordered
                                onClick={() => setTypeValue(false)}
                            >
                                {t('ticket.tax.addTaxeModale.fixedAmount')}
                            </RadioLabel>
                        </Card.Content>

                        <Form.Label style={{ marginTop: '15px' }} label={t('ticket.tax.addTaxeModale.salePriceIncludingTax')} />
                        <CurrencyInput
                            value={currancyValue}
                            style={{ width: '150px' }}
                            currency={currancy}
                            symbol={typeValue ? '%' : undefined}
                            numberDecimals={2}
                            onChange={e => {
                                setCurrancyValue(e.value);
                            }}
                            locale={locale}
                        />
                    </Form>
                </Card.Content>
            )}
        </Modal>
    );
}

AddTaxesModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    eventId: PropTypes.string.isRequired,
    taxTree: PropTypes.object.isRequired,
    reloadTree: PropTypes.func.isRequired
};
